import React, { useRef, useState } from "react";
import cn from "classnames";

const CsvFileInput = ({ onFilesChanged }) => {
  const [dropDepth, setDropDepth] = useState(0);
  const [inDropZone, setInDropZone] = useState(false);
  const fileInput = useRef();

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDropDepth(dropDepth + 1);
  };
  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDropDepth(dropDepth - 1);
    if (dropDepth > 0) return;
    setInDropZone(false);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "copy";
    setInDropZone(true);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let files = [...e.dataTransfer.files];

    if (files && files.length > 0) {
      files = files.filter((f) => f.type.includes("csv"));

      onFilesChanged?.([...files]);
      fileInput.current.value = "";

      setDropDepth(0);
      setInDropZone(false);
      e.dataTransfer.clearData();
    }
  };

  const onFileChange = (e) => {
    let files = [...e.target.files];

    if (files && files.length > 0) {
      files = files.filter((f) => f.type.includes("csv"));
      onFilesChanged?.([...files]);
      fileInput.current.value = "";
    }
  };

  return (
    <div
      className={cn("my-8 grid justify-items-stretch", {
        "bg-yellow-50": inDropZone,
      })}
      onDrop={(e) => handleDrop(e)}
      onDragOver={(e) => handleDragOver(e)}
      onDragEnter={(e) => handleDragEnter(e)}
      onDragLeave={(e) => handleDragLeave(e)}
    >
      <input
        type="file"
        onChange={onFileChange}
        id="file"
        className="h-0"
        ref={fileInput}
      />
      <label
        htmlFor="file"
        className="cursor-pointer p-12 text-center border-dashed border-2 rounded-md text-black"
      >
        Upload a file or drag and drop
      </label>
    </div>
  );
};
export default CsvFileInput;
